import script from "./fileChoose.vue?vue&type=script&setup=true&lang=js"
export * from "./fileChoose.vue?vue&type=script&setup=true&lang=js"

import "./fileChoose.vue?vue&type=style&index=0&id=e15891da&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e15891da"]])

export default __exports__